import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { list, find, save, remove } from '../../services/costConcept'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'

function* fetchCostConceptsRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchCostConcepts_filter'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.size = fe.size || 15
    fe.index = fe.index || 0
    fe.searchTerm = fe.searchTerm || '%20'
    fe.orderBy = fe.orderBy || '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_COSTCONCEPT,
    result,
  })
}

function* fetchCostConcepts({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchCostConcepts_filter'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem(
    'fetchCostConcepts_filter',
    JSON.stringify({ size, index, searchTerm, orderBy }),
  )
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_COSTCONCEPT,
    result,
  })
}

function* fetchCostConceptEdit({ id, openModal }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id, openModal)
  yield put({
    type: actions.EDIT_COSTCONCEPT,
    result,
    openModal,
  })
}

function* fetchCostConceptSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  console.log('fetchCostConceptSave', result)
  yield put({
    type: actions.SAVE_COSTCONCEPT_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_COSTCONCEPTS,
  })
}

function* fetchCostConceptDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_COSTCONCEPT_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_COSTCONCEPTS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_COSTCONCEPTS, fetchCostConcepts),
    takeEvery(actions.FETCH_COSTCONCEPT, fetchCostConceptEdit),
    takeEvery(actions.SAVE_COSTCONCEPT, fetchCostConceptSave),
    takeEvery(actions.DELETE_COSTCONCEPT, fetchCostConceptDelete),
    takeEvery(actions.RE_FETCH_COSTCONCEPTS, fetchCostConceptsRefresh),
  ])
}
